<template>
  <div>
    <base-navigation></base-navigation>
 
  <div class="registration-form">
    <h2>User Registration</h2>
    <form @submit.prevent="registerUser">
      <div class="form-group">
        <label for="email">Email:</label>
        <input
          type="email"
          id="email"
          v-model="user.email"
          placeholder="Enter your email"
          required
        />
      </div>

      <div class="form-group">
        <label for="phone">Phone:</label>
        <input
          type="tel"
          id="phone"
          v-model="user.phone"
          placeholder="Enter your phone number"
          required
          pattern="^[0-9]{10,15}$"
        />
      </div>

      <div class="form-group">
        <label for="password">Password:</label>
        <input
          type="password"
          id="password"
          v-model="user.password"
          placeholder="Enter your password"
          required
          minlength="8"
        />
      </div>

      <button type="submit" :disabled="isSubmitting">
        {{ isSubmitting ? "Registering..." : "Register" }}
      </button>
    </form>

    <p v-if="message">{{ message }}</p>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: "",
        phone: "",
        password: "",
      },
      isSubmitting: false,
      message: "",
    };
  },
  methods: {
    async registerUser() {
      if (!this.user.email || !this.user.phone || !this.user.password) {
        this.message = "Please fill in all fields.";
        return;
      }
      try {
        this.isSubmitting = true;
        const response = await fetch("https://api.roberms.com/fundraise/register/user", {
          method: "POST",
          // headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.user),
        });
        const result = await response.json();
        if (response.ok) {
          this.message = "Registration successful!";
        } else {
          this.message = result.message || "Registration failed.";
        }
      } catch (error) {
        this.message = "Error during registration. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.registration-form {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 16px;
}

label {
  display: block;
  margin-bottom: 4px;
}

input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #cccccc;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
}

p {
  color: green;
}
</style>
